"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InternalProgressBar = void 0;
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var styles = function styles(theme) {
  return {
    progressBar: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      height: '1rem',
      borderRadius: '.5rem',
      overflow: 'hidden',
      flexGrow: 1,
      marginRight: '1rem',
      background: '#eaeaea',
      border: '1px solid rgba(0, 0, 0, 0.87)'
    },
    progressBarWrapper: {
      display: 'flex',
      alignItems: 'center',
      marginRight: '1rem'
    },
    colorPrimary: {
      backgroundColor: '#eaeaea'
    },
    barColorPrimary: {
      backgroundColor: '#4dc0e8 !important'
    }
  };
};
var ProgressBarBase = function ProgressBarBase(_ref) {
  var value = _ref.value,
    classes = _ref.classes,
    style = _ref.style;
  var percent = value * 100;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.progressBarWrapper
  }, /*#__PURE__*/_react["default"].createElement(_material.LinearProgress, {
    value: Math.ceil(percent),
    variant: "determinate",
    className: classes.progressBar,
    classes: {
      colorPrimary: classes.colorPrimary,
      barColorPrimary: classes.barColorPrimary
    }
  }), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "subtitle1"
  }, Math.ceil(percent), " %"));
};
ProgressBarBase.propTypes = {
  value: _propTypes["default"].number.isRequired,
  classes: _propTypes["default"].object.isRequired,
  style: _propTypes["default"].object
};
var InternalProgressBar = exports.InternalProgressBar = (0, _styles.withStyles)(styles, {
  name: 'InternalProgressBar'
})(ProgressBarBase);